/**
 * Styles for the VoiceNotes component.
 */

import { StyleSheet } from 'react-native';
import { color, space, text, icon, radius } from '../../../shared/tokens/mobile';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: color.surface,
    borderRadius: radius.md,
    padding: space.md,
    marginHorizontal: space.md,
    marginBottom: space.md,
    borderWidth: 1,
    borderColor: color.divider,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: space.sm,
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.xs,
  },
  headerTitle: {
    fontSize: text.bodyMedium.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.textPrimary,
  },
  countBadge: {
    backgroundColor: color.primary + '15',
    borderRadius: radius.full,
    paddingHorizontal: space.xs + 2,
    paddingVertical: 1,
  },
  countText: {
    fontSize: 11,
    fontWeight: '600',
    color: color.primary,
  },
  recordButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: color.primary,
    borderRadius: radius.full,
    paddingHorizontal: space.sm + 2,
    paddingVertical: space.xs,
  },
  recordButtonActive: {
    backgroundColor: color.error,
  },
  recordButtonDisabled: {
    opacity: 0.6,
  },
  recordButtonText: {
    fontSize: text.caption.fontSize,
    fontWeight: '600',
    color: color.surface,
  },
  recordDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: color.surface,
  },
  recordTimerText: {
    fontSize: text.caption.fontSize,
    fontWeight: '700',
    color: color.surface,
    fontVariant: ['tabular-nums'],
  },
  loader: {
    paddingVertical: space.md,
  },
  emptyText: {
    fontSize: text.caption.fontSize,
    color: color.textMuted,
    textAlign: 'center',
    paddingVertical: space.sm,
  },
  noteCard: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: space.sm,
    borderTopWidth: 1,
    borderTopColor: color.divider,
    gap: space.sm,
  },
  playButton: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: color.primary + '15',
    alignItems: 'center',
    justifyContent: 'center',
  },
  playButtonActive: {
    backgroundColor: color.primary,
  },
  noteInfo: {
    flex: 1,
  },
  noteTopRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.xs,
  },
  noteDuration: {
    fontSize: text.body.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.textPrimary,
    fontVariant: ['tabular-nums'],
  },
  geoBadge: {
    backgroundColor: color.success + '15',
    borderRadius: radius.full,
    padding: 2,
  },
  noteTime: {
    fontSize: text.caption.fontSize,
    color: color.textMuted,
    marginTop: 1,
  },
  noteCaption: {
    fontSize: text.caption.fontSize,
    color: color.textSecondary,
    marginTop: 2,
  },
  deleteButton: {
    padding: space.xs,
  },
  showMore: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    paddingVertical: space.sm,
    borderTopWidth: 1,
    borderTopColor: color.divider,
  },
  showMoreText: {
    fontSize: text.caption.fontSize,
    color: color.primary,
    fontWeight: '500',
  },
  errorText: {
    fontSize: text.caption.fontSize,
    color: color.error,
    textAlign: 'center',
    paddingVertical: space.xs,
  },
  confirmOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 100,
    borderRadius: radius.md,
  },
  confirmCard: {
    backgroundColor: color.surface,
    borderRadius: radius.lg,
    padding: space.lg,
    width: '90%',
    maxWidth: 300,
  },
  confirmTitle: {
    fontSize: text.bodyMedium.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.textPrimary,
    textAlign: 'center',
    marginBottom: space.xs,
  },
  confirmMessage: {
    fontSize: text.caption.fontSize,
    color: color.textSecondary,
    textAlign: 'center',
    marginBottom: space.md,
  },
  confirmActions: {
    flexDirection: 'row',
    gap: space.sm,
  },
  confirmBtn: {
    flex: 1,
    paddingVertical: space.sm,
    borderRadius: radius.md,
    alignItems: 'center',
    justifyContent: 'center',
  },
  confirmCancelBtn: {
    backgroundColor: color.backgroundSecondary,
  },
  confirmCancelText: {
    fontSize: text.caption.fontSize,
    fontWeight: '600',
    color: color.textSecondary,
  },
  confirmDeleteBtn: {
    backgroundColor: color.error,
  },
  confirmDeleteText: {
    fontSize: text.caption.fontSize,
    fontWeight: '600',
    color: color.surface,
  },
});
